import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      transform: 'translate(34px, 20px) scale(1);',
    },
    '&.Mui-focused .MuiInputLabel-outlined': {
      color: 'purple',
    },
  },
  inputRoot: {
    color: 'purple',
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
      paddingLeft: 26,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'green',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'purple',
    },
  },
  body: {
    backgroundColor: '#101012',
  },
  main: {
    marginTop: '-70px',
    margin: '0 -2.5rem',
    padding: '0 2.5rem',
    paddingLeft: '3rem',
    paddingTop: '100px',
    height: '100%',
    backgroundColor: '#101012',
    minHeight: '100vh',
    '@media (max-width: 600px)': {
      marginTop: '0',
      marginLeft: '-2.5rem',
      paddingTop: '65px',
      paddingLeft: '2.5rem',
      marginRight: '-2.5rem',
      height: '100%',
      paddingRight: '2.5rem',
    },
    '@media (max-width: 960px)': {
      height: '100%',
    }
  },
  topBar: {
    marginBottom: '2rem',
    marginStart: '0.8rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0rem',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '0rem',
      marginStart: '0rem',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%', // 전체 너비를 차지하도록 설정
    '@media (max-width: 960px)': {
      flexDirection: 'column',
    },
  },
  leftColumn: {
    flex: '0 1 37%', // 기본적으로 45%를 차지하도록 설정
    overflowY: 'auto', // 수직 스크롤을 활성화
    maxHeight: '100vh', // 화면 높이에 맞게 설정
    paddingRight: '1rem', // 스크롤바 공간 확보
    '&::-webkit-scrollbar': {
      display: 'none', // 크롬, 사파리, 엣지에서 스크롤바 숨김
    },
    '-ms-overflow-style': 'none', // 인터넷 익스플로러, 엣지에서 스크롤바 숨김
    'scrollbar-width': 'none', // 파이어폭스에서 스크롤바 숨김
    '@media (max-width: 960px)': {
      maxHeight: '50vh',
    },
    '@media (max-width: 600px)': {
      flex: '0 1 100%', // 모바일에서 전체 너비를 차지하도록 설정
      maxWidth: '100%',
      maxHeight: '45vh', // 모바일에서 높이 제한 해제
      paddingRight: '0', // 모바일에서 스크롤바 공간 확보
      marginBottom: '1rem',
      marginTop: '-0.2rem',
    },
    '@media (max-width: 1180px)': {
      flex: '0 1 70%',
    },
  },
  rightColumn: {
    flex: '1', // 남은 공간을 모두 차지하도록 설정
    width: '100%',
    maxWidth: '100%',
    overflowY: 'auto', // 수직 스크롤을 활성화
    maxHeight: '100vh', // 화면 높이에 맞게 설정
    position: 'relative', // relative로 설정하여 sticky 요소가 기준점을 가질 수 있게 함
    '&::-webkit-scrollbar': {
      display: 'none', // 크롬, 사파리, 엣지에서 스크롤바 숨김
    },
    '-ms-overflow-style': 'none', // 인터넷 익스플로러, 엣지에서 스크롤바 숨김
    'scrollbar-width': 'none', // 파이어폭스에서 스크롤바 숨김
    '@media (max-width: 600px)': {
      maxWidth: '100%',
      maxHeight: 'unset', // 모바일에서 높이 제한 해제
    },
  },
  pageTitle: {
    fontSize: '1.5rem',
    color: '#fff',
    alignItems: 'center',
    display: 'flex',
    paddingStart: '0.8rem',
    width: '100%',
    position: 'sticky',  // 상단에 고정
    top: 0,             // 페이지 최상단에 고정
    backgroundColor: '#101012', // 배경색 설정하여 스크롤 시 잘 보이도록
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
      paddingStart: '0rem',
    },
  },
  pageSmallTitle: {
    paddingLeft: '1rem',
    fontSize: '1rem',
    color: '#fff',
    alignItems: 'center',
    display: 'flex',
    '@media (max-width: 600px)': {
      fontSize: '1rem',
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    color: '#101012',
    marginTop: '-0.5rem',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#A4A4A4',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
  selected: {
    backgroundColor: '#F0F0F0!important',
    borderRadius: '0.2rem!important',
  },
  cardGrid: {},
  card: {
    display: 'flex',
    border: '0.1rem solid #2d2e2f',
    backgroundColor: '#1c1c1c',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0.4rem 0.3rem 0.4rem 0.5rem',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    maxWidth: '45%',
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    marginLeft: '0.9rem',
    transition: 'transform 0.3s ease-in-out',
    [theme.breakpoints.down(680)]: {
      maxWidth: '45%',
      marginRight: '0',
    },
    [theme.breakpoints.down('1180')]: {
      borderRadius: '0.5rem',
      color: '#fff',
      fontSize: '0.9rem',
      fontWeight: '400',
      maxWidth: '80%',
      marginBottom: '0.5rem',
      marginTop: '0.5rem',
      marginLeft: '0.33rem',
    },
    [theme.breakpoints.down(476)]: {
      fontSize: '0.75rem',
      padding: '.4rem',
      paddingBottom: '.3rem',
      marginLeft: '0',
      height: '5.3rem',
      maxWidth: '25rem',
    },
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.02)',
    },
  },
  fullWidthCard: {
    display: 'flex',
    border: '0.1rem solid #2d2e2f',
    backgroundColor: '#1c1c1c',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0.4rem 0.3rem 0.4rem 0.5rem',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    maxWidth: '30%',
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
    marginLeft: '0.9rem',
    transition: 'transform 0.3s ease-in-out',
    [theme.breakpoints.down(680)]: {
      maxWidth: '45%',
      marginRight: '0',
    },
    [theme.breakpoints.down('1180')]: {
      padding: '0.2rem 0.1rem 0.2rem 0.3rem',
      borderRadius: '0.5rem',
      color: '#fff',
      fontSize: '0.9rem',
      fontWeight: '400',
      maxWidth: '45%',
      marginBottom: '0.5rem',
      marginTop: '0.5rem',
      marginLeft: '0.33rem',
    },
    [theme.breakpoints.down(476)]: {
      fontSize: '0.75rem',
      padding: '.4rem',
      paddingBottom: '.3rem',
      marginLeft: '0',
      height: '5.3rem',
      maxWidth: '25rem',
    },
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.02)',
    },
  },
  cardSecondColumn: {
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
  },
  cardLabelUsername: {
    alignSelf: 'flex-end',
    fontSize: '0.7rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginBottom: '0.3rem',
    '@media (max-width: 600px)': {
      fontSize: '0.58rem',
      marginLeft: '0.5rem',
    },
  },
  cardDescription: {
    display: '-webkit-box',
    flex: 1,
    fontSize: '0.56rem',
    color: '#d3d3d3',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    lineHeight: '1.0rem',
    height: '2.4rem',
    maxHeight: '2rem',
    marginLeft: '1.25rem',
    '@media (max-width: 600px)': {
      fontSize: '0.7rem',
      marginLeft: '0.5rem',
      lineHeight: '0.7rem',
      height: '2.0rem',
      maxHeight: '2.0rem',
    },
    '@media (min-width: 1100px)': {
      fontSize: '0.7rem',
      marginLeft: '0.5rem',
      lineHeight: '1.0rem',
      height: '2.4rem',
    },
    '@media (max-width: 1180px)': {
      marginLeft: '0',
    },
  },
  cardLabelContainer: {
    marginBottom: '0.7rem',
    marginLeft: '0.5rem',
    '@media (max-width: 600px)': {
      marginLeft: '0',
    },
    "@media (max-width: 1180px)": {
      marginLeft: '0',
    },
  },
  cardLabel: {
    flex: 1,
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'top',
    fontSize: '0.8rem',
    marginLeft: '0.7rem',
    marginTop: '0.3rem',
    flexWrap: 'wrap',
    height: 'auto',
    overflow: 'hidden',
    overflowWrap: 'anywhere',
    '@media (max-width: 600px)': {
      fontSize: '1rem',
      marginLeft: '0.5rem',
      marginTop: '0.3rem',
      marginBottom: '0.5rem',
    },
    '@media (min-width: 1180px)': {
      fontSize: '0.8rem',
      marginTop: '0.3rem',
      marginLeft: '0',
      marginBottom: '0.5rem',
    },
    '@media (max-width: 1180px)': {
      marginLeft: '0',
    },
  },
  editIcon: {
    width: '1.2rem!important',
    marginLeft: '0.3rem',
    cursor: 'pointer',
  },
  cardCreatedAt: {
    alignSelf: 'flex-start',
    fontSize: '0.7rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      fontSize: '0.6rem',
      marginLeft: '0.5rem',
    },
  },
  cardTimestamp: {
    alignItems: 'bottom',
    display: 'flex',
    marginLeft: '0.3rem',
    flex: 1,
    fontSize: '0.7rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.down(476)]: {
      fontSize: '0.6rem',
    },
  },
  cardLikes: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '1.2rem',
  },
  cardBottomRight: {
    justifyContent: 'flex-end',
  },
  numberPlayed: {
    color: '#d3d3d3',
    fontSize: '0.8rem',
    marginLeft: '0.3rem',
    [theme.breakpoints.down(476)]: {
      fontSize: '0.7rem',
    },
  },
  creations: {
    color: '#d3d3d3',
    fontSize: '0.6rem',
    marginLeft: '.2rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginBottom: '0.07rem',
    [theme.breakpoints.down(476)]: {
      fontSize: '0.5rem',
    },
  },
  creationsGrid: {
    alignItems: 'flex-end',
    marginBottom: '0.5rem',
  },
  cardStatus: {
    textAlign: 'center',
    marginLeft: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '0.8rem',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      marginLeft: '0rem',
    },
  },
  cardAction: {
    cursor: 'pointer',
    width: '2.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '0.3rem',
    [theme.breakpoints.down('xs')]: {
      width: '2.5rem',
    },
  },
  tooltipImg: {
    marginLeft: '0.5rem',
    width: '1.3rem',
  },
  tooltipContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    [theme.breakpoints.down('xs')]: {
      padding: '1rem 0',
    },
    padding: '1rem',
    color: '#161616',
  },
  tooltipHeader: {
    alignSelf: 'center',
    fontSize: '1.5rem',
    fontWeight: '500',
    marginBottom: '1rem',
  },
  tooltipSubeaderCenter: {
    alignSelf: 'center',
    marginTop: '1.3rem',
    marginBottom: '0.8rem',
    fontSize: '1.1rem',
    fontWeight: '500',
  },
  tooltipTextContainer: {
    display: 'flex',
  },
  tooltipText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
      lineHeight: '1rem',
    },
    fontSize: '1.1rem',
    fontWeight: '300',
    margin: '0.3rem 0',
    lineHeight: '1.3rem',
  },
  tooltipTextNumber: {
    marginRight: '0.2rem',
  },
  tooltipTextBullet: {
    marginLeft: '0.5rem',
    marginRight: '0.8rem',
  },
  infoIconAction: {
    width: '2.5rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '0.3rem',
    [theme.breakpoints.down('xs')]: {
      width: '2.5rem',
    },
  },
  infoIconImg: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentcolor',
    flexShrink: '0',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
  },
  infoIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '0.2rem',
    color: '#161616',
  },
  infoIconTextContainer: {
    flexDirection: 'column',
    alignItems: 'stretch',
    color: '#161616',
  },
  infoIconTextLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.2rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  infiniteScroll: {
    marginTop: '-0.5rem',
  },
  infoIconTextBold: {
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  infoIconText: {
    fontSize: '0.9rem',
    fontWeight: '400',
  },
  pagination: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#ffffff',
    margin: '1rem 0',
  },
  imgContainer: {
    width: '4rem',
    height: '4rem',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    flexGrow: 0,
    '@media (max-width: 600px)': {
      width: '3.5rem',
      height: '3.5rem',
      marginRight: '0.2rem',
    },
    '@media (min-width: 601px and max-width: 960px)': {
      width: '3.5rem',
      height: '3.5rem',
    },
    '@media (max-width: 1180px)': {
      paddingStart: '0.25rem',
    },
  },
  coverImg: {
    userSelect: 'none',
    width: '3rem',
    height: '3rem',
    display: 'inline-block',
    fill: 'currentcolor',
    flexShrink: '1',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
    borderRadius: '50%',
    border: '0.07rem solid #808080',
    marginRight: '0.5rem',
    '@media (max-width: 600px)': {
      width: '3.5rem',
      height: '3.5rem',
    },
    '@media (min-width: 601px and max-width: 960px)': {
      width: '3.5rem',
      height: '3.5rem',
    },
  },
  playButtonImg: {
    userSelect: 'none',
    flexShrink: '0',
    fontSize: '50px',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  playButtonGrid: {
    direction: 'row',
    justifyContent: 'flex-end',
  },
  likeButtonImg: {
    marginTop: '3.2rem',
    userSelect: 'none',
    display: 'inline-block',
    marginLeft: '0.5rem',
    flexShrink: '0',
    fontSize: '2px',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  favoriteImg: {
    userSelect: 'none',
    flexShrink: '0',
    fontSize: '2rem',
    cursor: 'pointer',
    borderRadius: '0.1rem',
  },
  favoriteFullImg: {
    userSelect: 'none',
    flexShrink: '0',
    fontSize: '2rem',
    cursor: 'pointer',
    borderRadius: '0.1rem',
    color: '#d32f2f',
  },
  sortItem: {
    color: '#8c8e97',
  },
  sortSelect: {
    color: '#8c8e97 !important',
  },
  menuList: {
    color: '#8c8e97 !important',
    backgroundColor: '#101012 !important',
    marginTop: '-8px !important',
    marginBottom: '-8px !important',
  },
  selectInput: {
    color: '#8c8e97 !important',
    fontSize: '0.8rem !important',
  },
  selectIcon: {
    color: '#8c8e97 !important',
  },
  numberLikes: {
    fontSize: '0.8rem',
    marginLeft: '.1rem',
    marginRight: '.1rem',
  },
  tagAutoComplete: {
    [theme.breakpoints.down('xs')]: {
      padding: '0.2rem 0.5rem!important',
      width: '100%',
    },
    '&::placeholder': {
      color: '#818181',
      fontSize: '0.9rem',
      fontWeight: '400',
      border: 'none!important',
    },
    width: '100%',
    maxWidth: '100%',
    borderRadius: '0.2rem',
    border: 'none!important',
    color: '#000',
    fontSize: '0.9rem',
    fontWeight: '400',
    outline: 'none',
    backgroundColor: '#fff',
  },
  sortItem: {
    color: '#8c8e97',
  },
  sortSelect: {
    fontFamily: 'TheJamsil, sans-serif',
    backgroundColor: '#101012',
    color: '#8c8e97',
    height: '2.5rem',
    [theme.breakpoints.down(1134)]: {
      width: '6',
    },
    width: '7',
    '& .MuiSelect-select': {
      color: '#fff',
      fontFamily: 'TheJamsil, sans-serif',
    },
    '& .MuiMenuItem-root': {
      color: '#fff',
      fontFamily: 'TheJamsil, sans-serif',
    },
    '& .MuiMenuItem-input': {
      color: '#fff',
      fontFamily: 'TheJamsil, sans-serif',
    },
    '& .MuiList-root': {
      backgroundColor: '#fff',
    },
    '& .MuiSelect-icon': {
      color: '#fff',
    },
  },
  filterSortContainer: {
    [theme.breakpoints.down('s')]: {
      maxWidth: '25rem',
    },
    [theme.breakpoints.up(1135)]: {
      maxWidth: '51rem',
    },
    [theme.breakpoints.up(1550)]: {
      maxWidth: '77rem',
    },
    [theme.breakpoints.up(1965)]: {
      maxWidth: '103rem',
    },
    maxWidth: '25rem',
    display: 'flex',
    marginBottom: '1rem',
    justifyContent: 'space-between',
  },
  searchButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '3rem',
    width: '100%',
  },
  recentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    color: '#101012',
    width: '97%',
    position: 'sticky',  // 상단에 고정
    top: 0,             // 페이지 상단에 고정
    zIndex: 1000,       // 다른 요소보다 위에 배치
    backgroundColor: '#101012', // 배경색 설정하여 스크롤 시 잘 보이도록
    '@media (max-width: 960px)': {
      zIndex: 0,
    },
    '@media (max-width: 1180px)': {
      width: '85%',
    },
  },
  searchbarContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
  },
  searchbar: {
    backgroundColor: '#2d2e2f',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0.2rem 0.5rem!important',
      width: '100%',
    },
    '&::placeholder': {
      color: '#8c8e97',
      fontSize: '0.9rem',
      fontWeight: '400',
      border: 'none!important',
    },
    margin: '0.3rem 0 0.5rem 0',
    width: '100%',
    maxWidth: '100%',
    height: '3rem',
    borderRadius: '0.4rem',
    border: 'none!important',
    padding: '1rem',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: '400',
    outline: 'none',
  },
  searchIcon: {
    position: 'absolute',
    right: '10px',
    color: '#fff',
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7rem',
    },
    [theme.breakpoints.down(1134)]: {
      width: '6.3rem',
      fontSize: '0.7rem',
      marginRight: '0.5rem',
    },
    backgroundColor: '#fff',
    margin: '.3rem 0 .5rem 0',
    marginRight: '3.5rem',
    width: 'auto',
    padding: '0.6rem',
    fontSize: '0.7rem',
    borderRadius: '0.2rem',
    textAlign: 'center',
    cursor: 'pointer',
    height: 'auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonIcon: {
    marginRight: '0.3rem',
    width: '1rem',
    height: '1rem',
    fill: 'currentColor',
  },
  filterContainer: {
    display: 'flex',
    width: '8rem',
    alignItems: 'center',
    fontSize: '1.1rem',
    textAlign: 'center',
    cursor: 'pointer',
    height: '3rem',
    justifyContent: 'center',
  },
  filterIcon: {
    color: '#818181',
    marginRight: '0.5rem',
  },
}));

export { useStyles };
